/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-document-sub-categories';

export const EntityDocumentSubCategoryApi = {
  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithEntity: async () => {
    const url = `${pathname}/find-with-entity`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: FilterEntityDocumentSubCategoryOption) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: CreateEntityDocumentSubCategoryBody) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (params: {
    id: string;
    body: UpdateEntityDocumentSubCategoryBody;
  }) => {
    const { id, body } = params;

    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterEntityDocumentSubCategoryOption {
  page?: number;
  take?: number;
  skip?: number;
  reserved?: boolean;
  type?: number;
  name?: number;
  order?: any;
  entityID?: string;
  entityDocumentCategoryID?: string;
}

export interface CreateEntityDocumentSubCategoryBody {
  entityDocumentCategoryID: string;
  name?: string;
  description?: string;
}

export interface UpdateEntityDocumentSubCategoryBody {
  entityDocumentCategoryID: string;
  name?: string;
  description?: string;
  status?: number;
}
